// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__yrDag","menu-desktop":"Menu_menu-desktop__RTp98","menu-icons":"Menu_menu-icons__yKQRQ"};